import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { ExperienceFlowStoreType } from '@/services/experienceFlows/types'
import { buildExperienceFlowDefaultParams } from '@gh/common/models'

export const useExperienceFlowDefaultStore = defineStore<
  'experienceFlow_Default',
  ExperienceFlowStoreType
>('experienceFlow_Default', () => {
  const store = computed(() => buildExperienceFlowDefaultParams())

  return {
    empty: computed(() => store.value.empty),
    sponsorScreenAfterClassSelection: computed(() => store.value.sponsorScreenAfterClassSelection),
  }
})
